<template>
  <section class="bootcamps">
    <div class="bootcamps__header-wrapper">
      <h1 class="bootcamps__header">
        <HeaderIcon class="bootcamps__header--icon" /> BOOTCAMPS
      </h1>
    </div>
    <template v-if="isPageLoading">
      <BootcampCardSkel />
      <BootcampCardSkel />
      <BootcampCardSkel />
    </template>
    <template v-else>
      <div
        v-if="!next && !upcoming.length && !current.length"
        class="bootcamps__section-wrapper"
      >
        <h4 class="bootcamps__none-available">
          No Upcoming Bootcamps at this Time
        </h4>
        <router-link :to="{ name: 'home' }" class="btn btn--primary"
          >Home
        </router-link>
      </div>
      <div v-if="current && current.length" class="bootcamps__section-wrapper">
        <h4 class="bootcamps__section-title">Happening Now</h4>
        <FeaturedBootcamp
          v-for="bootcamp in current"
          :key="bootcamp.id"
          v-bind="{
            bootcamp,
            isActionLoading,
            formatDate,
            renderMarkdown,
          }"
        />
      </div>
      <div v-if="next" class="bootcamps__section-wrapper">
        <h4 class="bootcamps__section-title">Next Bootcamp</h4>
        <FeaturedBootcamp
          v-bind="{
            bootcamp: next,
            formatDate,
            renderMarkdown,
          }"
        />
      </div>
      <div
        v-if="upcoming && upcoming.length"
        class="bootcamps__section-wrapper"
      >
        <h4 class="bootcamps__section-title">Upcoming Bootcamps</h4>
        <BootcampCard
          v-for="bootcamp in upcoming"
          :key="bootcamp.id"
          v-bind="{
            bootcamp,
            formatDate,
            renderMarkdown,
          }"
        />
      </div>
      <div
        v-if="past && past.length"
        class="bootcamps__section-wrapper bootcamps__past-section"
      >
        <h4 class="bootcamps__section-title">Previous Bootcamps</h4>
        <PastBootcampCard
          v-for="bootcamp in past"
          :key="bootcamp.id"
          v-bind="{
            bootcamp,
            formatDate,
            renderMarkdown,
          }"
        />
      </div>
    </template>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatDateForBootcamp } from '@/helpers'
import BootcampCardSkel from '@/components/loaders/skeletons/bootcamps/BootcampCardSkel.vue'
import FeaturedBootcamp from '@/components/bootcamps/FeaturedBootcamp.vue'
import BootcampCard from '@/components/bootcamps/BootcampCard.vue'
import PastBootcampCard from '@/components/bootcamps/PastBootcampCard.vue'
import HeaderIcon from '@/assets/icons/bootcamps/header_icon.svg'

const marked = require('marked')

export default {
  name: 'Bootcamps',
  components: {
    BootcampCardSkel,
    FeaturedBootcamp,
    BootcampCard,
    HeaderIcon: { ...HeaderIcon, name: 'HeaderIcon' },
    PastBootcampCard,
  },
  data() {
    return {
      formatDate: formatDateForBootcamp,
      selectedBootcamp: null,
    }
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
      isActionLoading: state => state.app.isComponentLoading,
      isAdmin: state => state.auth.isAdmin,
      isContentCreator: state => state.auth.isContentCreator,
    }),
    ...mapGetters('bootcamps', ['next', 'upcoming', 'past', 'current']),
  },
  methods: {
    renderMarkdown(string) {
      return marked(string)
    },
  },
  async created() {
    this.$store.dispatch('app/setIsComponentLoading', false)
    this.$store.dispatch('app/setIsPageLoading', true)
    await this.$store.dispatch('bootcamps/getCurrentBootcamps')
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss">
.bootcamps {
  padding: 125px 25px 50px 25px;
  max-width: 2400px;
  margin: 0 auto;
  @include tablet {
    padding: 125px 50px 150px 50px;
  }
  @include desktop {
    padding: 125px 150px 150px 150px;
  }
  &__header-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__header {
    display: flex;
    align-items: center;
    background-color: var(--darker-gray);
    padding: 10px 30px;
    border-radius: 100px;
    margin: 0;
    font-size: rem(13px);
    color: var(--white);
    &--icon {
      margin: 3px 15px 0 0;
    }
  }
  &__section-wrapper {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 0 25px 0;
    width: 100%;
  }
  &__past-section {
    justify-content: left;
    max-width: 1600px;
    margin: auto;
  }
  &__section-title {
    text-transform: uppercase;
    font-size: rem(14px);
    color: var(--white);
    width: 100%;
    margin: 0 auto;
    @include lg-desktop {
      max-width: 1600px;
    }
  }
  &__none-available {
    text-transform: uppercase;
    font-size: rem(16px);
    color: var(--white);
    text-align: center;
    margin: 100px auto 0 auto;
    width: 100%;
  }
  &__home-btn {
    margin: 50px auto 0 auto;
  }
}
</style>
